export default "__VITE_ASSET__a64c965f__"